import './CustomizeChinese.module.css';

import {
  Typography
} from '@material-ui/core';
import React from 'react';

import CustomizeBoard from '../../CustomizeBoard';
import NavigationWrap from '../../NavigationWrap';
import WithProvider from '../../WithProvider';

export default function CustomizeChinesePage() {
  return (
    <NavigationWrap>
      <WithProvider>
        <CustomizeBoard />
      </WithProvider>
      <div styleName="wrap">
        <Typography component="h1" gutterBottom variant="h5">Create and customize your own Chinese Sudoku!</Typography>
        <Typography paragraph>
          Sudoku puzzles using Chinese characters are great for learning and differentiating characters. It can also be a fun way to practice writing character as well.
        </Typography>
      </div>
    </NavigationWrap>
  );
}
